/** First kickoff: Mexico vs South Africa, June 11 2026, 3:00 PM EDT */
export const FIRST_KICKOFF_UTC = new Date('2026-06-11T19:00:00Z');

const DEBUG_TIME_KEY = 'wcp_debug_time';

/**
 * Returns the current timestamp in ms.
 * In admin debug mode, returns the overridden time stored in localStorage.
 */
export function getNow() {
  const override = localStorage.getItem(DEBUG_TIME_KEY);
  if (override) {
    const parsed = parseInt(override, 10);
    if (!isNaN(parsed)) return parsed;
  }
  return Date.now();
}

export function setDebugTime(date) {
  if (date) {
    localStorage.setItem(DEBUG_TIME_KEY, String(date.getTime()));
  } else {
    localStorage.removeItem(DEBUG_TIME_KEY);
  }
}

export function getDebugTime() {
  const override = localStorage.getItem(DEBUG_TIME_KEY);
  if (!override) return null;
  const parsed = parseInt(override, 10);
  return isNaN(parsed) ? null : new Date(parsed);
}

/**
 * Returns true if league settings should be locked.
 * Checks both the Firestore `settingsLocked` flag and wall-clock time.
 */
export function isSettingsLocked(league) {
  if (!league) return false;
  return !!(league.settingsLocked || getNow() >= FIRST_KICKOFF_UTC.getTime());
}

/** Returns true when a round's picks are open for submission. */
export function isRoundOpen(round) {
  return round?.status === 'open';
}

/** Returns true when a round is no longer editable (locked or complete). */
export function isRoundLocked(round) {
  return round?.status === 'locked' || round?.status === 'complete';
}

/** Returns the round's lock time as a JS Date, or null if not set. */
export function getRoundLockTime(round) {
  return round?.lockTime?.toDate?.() ?? null;
}
